import { serviceName } from '../resources/serviceConstants';
import { OPPORTUNITIES_OVERVIEW_REPORTS, STAFF_AUGEMENTATION, STAFF_REQUIREMENT } from '../resources/endPoint';

// API call to get staff augmentation
export const getStaffAugmentation = (filters = {}) => {
  let url = STAFF_AUGEMENTATION;
  const queryParams = [];

  if (filters.staffingName) {
    queryParams.push(`name=${encodeURIComponent(filters.staffingName)}`);
  }

  if (filters.employeeName) {
    queryParams.push(`employee_name=${encodeURIComponent(filters.employeeName)}`);
  }

  if (filters.employeeId) {
    queryParams.push(`employee_id=${encodeURIComponent(filters.employeeId)}`);
  }

  if (filters.is_team_visible !== undefined) {
    queryParams.push(`is_team_visible=${encodeURIComponent(filters.is_team_visible)}`);
  } else if (filters.isTeamVisible !== undefined) {
    queryParams.push(`is_team_visible=${encodeURIComponent(filters.isTeamVisible)}`);
  }

  if (queryParams.length > 0) {
    url += `?${queryParams.join('&')}`;
  }

  return {
    url: url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};

export const deleteStaffAugmentation = (payload) => {
  // API call to delete staff augmentation
  return {
    url: STAFF_AUGEMENTATION,
    method: 'delete',
    headers: { 'Content-Type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    payload: payload,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};

export const addStaffAugmentation = (staffData) => {
  return {
    url: STAFF_AUGEMENTATION,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    authRequired: true,
    csrfToken: true,
    service: serviceName.STAFF_AUGMENTATION_MS,
    payload: staffData,
  };
};

// API call to update staff augmentation
export const updateStaffAugmentation = (data) => {
  return {
    url: `${STAFF_AUGEMENTATION}/`,
    method: 'put',
    headers: { 'content-type': 'multipart/form-data' },
    authRequired: false,
    csrfToken: true,
    payload: data,
    service: serviceName.STAFF_AUGMENTATION_MS,
    timeout: 300000,
  };
};

export const mapResource = (resourceData) => {
  return {
    url: STAFF_REQUIREMENT,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: serviceName.STAFF_AUGMENTATION_MS,
    payload: resourceData,
  };
};

export const getOpportunitiesOverview = (startDate, endDate, dealType) => {
  const buildQueryParams = () => {
    const params = [];

    if (startDate) params.push(`startDate=${startDate}`);
    if (endDate) params.push(`endDate=${endDate}`);

    if (Array.isArray(dealType) && dealType.length > 0) {
      dealType.forEach(dt => {
        params.push(`dealType=${dt}`);
      });
    }

    return params.length ? `?${params.join('&')}` : '';
  };

  const url = `${OPPORTUNITIES_OVERVIEW_REPORTS}${buildQueryParams()}`;

  return {
    url,
    method: 'get',
    headers: { 'content-type': 'application/json' },
    authRequired: false,
    csrfToken: true,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};

// API call to get employee names dropdown
export const getEmployeeNames = () => {
  return {
    url: `${STAFF_AUGEMENTATION}/employee-names`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};

// API call to get employee IDs dropdown
export const getEmployeeIds = () => {
  return {
    url: `${STAFF_AUGEMENTATION}/employee-ids`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    authRequired: true,
    csrfToken: true,
    service: serviceName.STAFF_AUGMENTATION_MS,
  };
};
